import {UseMutationOptions, useMutation, useQueryClient} from '@tanstack/react-query'
import {httpUpdatePersonalNotes} from '@features/assignment/http/assignment.http'
import {Assignment} from '@features/assignment/types.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'

export const useUpdatePersonalNotes = ({
    assignmentId,
    assignmentCode,
    options
}: {
    assignmentId: Assignment['id']
    assignmentCode: Assignment['code']
    options: Omit<UseMutationOptions<Assignment, unknown, string>, 'mutationFn'>
}) => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (notes: string) =>
            parseAxiosPromise({
                axiosPromise: httpUpdatePersonalNotes({
                    urlParams: {assignmentId},
                    payload: {notes},
                    params: {response_type: 'extended'}
                }),
                responseShape: Assignment,
                onZodError: captureException
            }),
        onError: errorHandler,
        ...options,
        onSuccess: (data, variables, context) => {
            queryClient.setQueryData(['assignment', assignmentCode], data)
            options.onSuccess?.(data, variables, context)
        }
    })
}
